<template>
  <div>
        <vs-card>
          <div>
        <!-- <pre>{{lessonLists}}</pre> --> 
         <!-- <pre>{{topicLists}}</pre>    -->
            <vs-table
              multiple
              v-model="selected"
              :data="topicLists"
            >
          
              <template slot="header">
                <h3>Topics List</h3>
                <!-- <pre>{{courseLists}}</pre> -->
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Description </vs-th>
                <vs-th> Subject </vs-th>
                <vs-th> No of Files </vs-th>
                <vs-th> Tags </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td >
                    {{ data[indextr].name }}
                  </vs-td>
                    <vs-td >
                    {{ data[indextr].description }}
                  </vs-td>
                
                  <vs-td>
                   <!-- <pre> {{data[indextr].subjects}}</pre> -->
                    <span v-for="(subject,index) in data[indextr].subjects" :key="index">
                              <span v-if="subject.subject"> {{subject.subject.subject_name}}</span> 
                    <span v-if="index+1 < data[indextr].subjects.length">, </span>
                    </span> 
                  </vs-td >
                        <vs-td >
                    {{data[indextr].topicFiles.length}}
                  </vs-td>

                  <vs-td>
                      <span v-for="(tag,tagindex) in data[indextr].topicTags" :key="tagindex">
                                {{tag.tag.name}}
                      <span v-if="tagindex+1 < data[indextr].topicTags.length">, </span>
                    </span> 
                   </vs-td>
                 
               
                </vs-tr>
              </template>
            </vs-table>
             <vs-button v-if="query_page.has_next" @click="loadMoreData" style="float:right">Load More Data</vs-button>
             <vs-button @click="exportTopicsData">Export to Course Builder</vs-button>
          </div>
     
        </vs-card>
    <!-- {{get_homework_subject_id}}
    {{statusstatus}} -->
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { topicListing} from '@/api/course-builderapi'
import {mapGetters} from 'vuex'


export default {
  components: {
    vSelect
    
  },
  data () {
    return {
      selected: [],
      topicLists:[],
      query_page:{
        'total': '',
        'limit': 10,
        'has_next': false,
        'current_page': 1,
        'next_page_url': null,
        'previous_page_url': ''
      }
    }
  },
  computed:{
    ...mapGetters(
      ['get_homework_subject_id']
    ),
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  mounted () {
    this.fetchTopicList()
    

  },
  props:{
    subject_ids:{
      type:Array,
      required:true,
      default:() => []
    }
  },
  methods:{
    
   
    async fetchTopicList () {
      try {
        this.$vs.loading({
          text:'Fetching Topics please wait ...'
        })
        let payload = {}
        if (this.subject_ids) {
          payload = {
            subject_ids:this.subject_ids
          }
          

        }
        const customer_id = this.$store.getters.customerId
        const responseList = await topicListing(customer_id, payload)
        
        this.topicLists =  responseList.data.data.topiclist
        
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }

    },
    //redirecting for editing
    openEditView (editingObject) {

      this.$router.push({
        name: 'course-builder',
        params: { editing_object: editingObject,
          editing_type:'topics',
          section:'topics'
        }
      })
      
    },
    loadMore () {
      this.loadMoreData()
    },
    async loadMoreData () {

      try {
        this.$vs.loading({
          text:'Fetching Topics please wait ...'
        })
        const customerId = this.$store.getters.customerId
        let payload = {}
        if (this.subject_ids) {
          payload = {
            subject_ids:this.subject_ids
          }
          
        }
        const { responseList } = await topicListing(customerId, payload,  this.query_page.current_page + 1)
        this.topicLists =  responseList.data.data.topiclist
        this.topicLists.push(...responseList.data.question_details)
        this.query_page = responseList.data.meta
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    exportTopicsData () {
      
      if (this.selected.length) {
        const obj = this.selected
        this.$emit('getTopicList', obj)
      }


    }
  }
  

}
</script>